import { useCallback, useEffect, useMemo, useState } from 'react';
export default function useRouter(routes) {
    if (!routes.length)
        throw new Error('Must specify at least one route.');
    const [[index, direction], setIndexAndDirection] = useState([0, -1]);
    const route = useMemo(() => routes[index], [routes, index]);
    const match = useCallback((routeToMatch) => routeToMatch.path === route.path, [route]);
    const setRoute = useCallback((to) => {
        const resolveIndex = () => {
            if (typeof to === 'number')
                return to;
            const path = typeof to === 'string' ? to : to.path;
            return routes.findIndex((route) => route.path === path);
        };
        const nextIndex = Math.max(0, Math.min(resolveIndex(), routes.length - 1));
        setIndexAndDirection(([thisIndex, thisDirection]) => {
            const nextDirection = thisIndex !== nextIndex ? nextIndex - thisIndex : thisDirection;
            return [nextIndex, nextDirection];
        });
    }, [routes, setIndexAndDirection]);
    // If routes change, reset route
    // This will e.g. deselect a selected marker when filters are changed
    useEffect(() => setRoute(0), [routes, setRoute]);
    return {
        index,
        direction,
        route,
        routes,
        match,
        setRoute,
    };
}
